"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceSchema = exports.deviceInitialized = void 0;
const joi_1 = __importDefault(require("joi"));
exports.deviceInitialized = {
    name: '',
    certName: '',
    location: '',
    certLocation: '',
    deviceLocation: '',
    tabletId: '',
    tabletName: '',
    tabletLocation: '',
    tabletLink: '',
    deviceURL: '',
    description: '',
    username: '',
    password: '',
    edge: '',
    deviceAuthID: '',
    gpioOne: '',
    gpioTwo: '',
    sensorKey: '',
    tapOne: '',
    tapTwo: '',
    place: null,
    connectID: '',
    connectTags: '',
    connectName: '',
    deviceSerialNumber: '',
    deviceSaleID: '',
};
exports.deviceSchema = joi_1.default.object({
    name: joi_1.default.any(),
    certName: joi_1.default.any(),
    location: joi_1.default.any(),
    certLocation: joi_1.default.any(),
    deviceLocation: joi_1.default.any(),
    tabletId: joi_1.default.any(),
    tabletName: joi_1.default.any(),
    tabletLocation: joi_1.default.any(),
    deviceAuthID: joi_1.default.any(),
    deviceURL: joi_1.default.any(),
    tabletLink: joi_1.default.any(),
    description: joi_1.default.any(),
    username: joi_1.default.any(),
    sensorKey: joi_1.default.any(),
    password: joi_1.default.any(),
    edge: joi_1.default.any(),
    gpioOne: joi_1.default.any(),
    gpioTwo: joi_1.default.any(),
    tapOne: joi_1.default.any(),
    tapTwo: joi_1.default.any(),
    place: joi_1.default.any(),
    connectID: joi_1.default.any(),
    connectTags: joi_1.default.any(),
    connectName: joi_1.default.any(),
    deviceSerialNumber: joi_1.default.string().optional().allow(''),
    deviceSaleID: joi_1.default.string().optional().allow(''),
});
